import { render, staticRenderFns } from "./CustomerPrivacyBoxs.vue?vue&type=template&id=f0474cb8"
import script from "./CustomerPrivacyBoxs.vue?vue&type=script&lang=ts"
export * from "./CustomerPrivacyBoxs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports